import script from "./NoticeDetails.vue?vue&type=script&async=true&setup=true&lang=ts"
export * from "./NoticeDetails.vue?vue&type=script&async=true&setup=true&lang=ts"

import "./NoticeDetails.vue?vue&type=style&index=0&id=2bb8b1e1&lang=css"

const __exports__ = script;

export default __exports__